import { render, staticRenderFns } from "./category-txt.vue?vue&type=template&id=acc638d2&scoped=true&"
import script from "./category-txt.vue?vue&type=script&lang=js&"
export * from "./category-txt.vue?vue&type=script&lang=js&"
import style0 from "./category-txt.vue?vue&type=style&index=0&id=acc638d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc638d2",
  null
  
)

export default component.exports